if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

/* Home of Hammam lightbox: one photo at a time, arrows, counter, keyboard, tap or click to zoom and pan */
(function () {
  if (window.__hohLb) return;
  window.__hohLb = true;
  function setup(modal) {
    if (modal.__hohLb) return modal.__hohLb;
    var box = modal.querySelector('.product-media-modal__content');
    var dialog = modal.querySelector('.product-media-modal__dialog');
    if (!box || !dialog) return null;
    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'hoh-lb-nav hoh-lb-prev'; prev.setAttribute('aria-label', 'Previous photo'); prev.innerHTML = '&#8249;';
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'hoh-lb-nav hoh-lb-next'; next.setAttribute('aria-label', 'Next photo'); next.innerHTML = '&#8250;';
    var count = document.createElement('div');
    count.className = 'hoh-lb-count'; count.setAttribute('aria-live', 'polite');
    var hint = document.createElement('div');
    hint.className = 'hoh-lb-hint';
    hint.textContent = window.matchMedia('(hover: hover)').matches ? 'Click the photo to zoom' : 'Tap the photo to zoom, swipe for more';
    dialog.appendChild(prev); dialog.appendChild(next); dialog.appendChild(count); dialog.appendChild(hint);
    /* The theme closes the photo viewer on any mouse click; keep it open for clicks on the photos and controls (close button and Esc still close it) */
    [box, prev, next, count].forEach(function (el) { el.addEventListener('pointerup', function (e) { e.stopPropagation(); }); });
    function slides() {
      return Array.prototype.filter.call(box.children, function (el) { return el.offsetParent !== null || el === document.activeElement; });
    }
    function index() {
      var s = slides(); var w = box.clientWidth || 1;
      return Math.max(0, Math.min(s.length - 1, Math.round(box.scrollLeft / w)));
    }
    function update() {
      var s = slides(); var i = index();
      count.textContent = (i + 1) + ' / ' + s.length;
      prev.disabled = i === 0; next.disabled = i >= s.length - 1;
    }
    function unzoom() {
      var z = box.querySelector('.hoh-zoomed');
      if (z) { z.classList.remove('hoh-zoomed'); z.style.transformOrigin = ''; }
      modal.classList.remove('hoh-lb-zooming');
    }
    function go(d) {
      unzoom();
      var s = slides(); var i = Math.max(0, Math.min(s.length - 1, index() + d));
      box.scrollTo({ left: i * box.clientWidth, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    box.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    function origin(img, x, y) {
      var r = img.getBoundingClientRect();
      var ox = Math.max(0, Math.min(100, ((x - r.left) / r.width) * 100));
      var oy = Math.max(0, Math.min(100, ((y - r.top) / r.height) * 100));
      img.style.transformOrigin = ox + '% ' + oy + '%';
    }
    box.addEventListener('click', function (e) {
      var img = e.target.closest && e.target.closest('img');
      if (!img || img.parentElement !== box) return;
      hint.style.display = 'none';
      if (img.classList.contains('hoh-zoomed')) { unzoom(); return; }
      unzoom();
      origin(img, e.clientX, e.clientY);
      img.classList.add('hoh-zoomed');
      modal.classList.add('hoh-lb-zooming');
    });
    box.addEventListener('mousemove', function (e) {
      var img = box.querySelector('.hoh-zoomed');
      if (img) origin(img, e.clientX, e.clientY);
    });
    var last = null;
    box.addEventListener('touchmove', function (e) {
      var img = box.querySelector('.hoh-zoomed');
      if (!img || e.touches.length !== 1) return;
      e.preventDefault();
      var t = e.touches[0];
      if (last) {
        var r = img.getBoundingClientRect();
        var cur = (img.style.transformOrigin || '50% 50%').split(' ').map(parseFloat);
        var nx = Math.max(0, Math.min(100, cur[0] - ((t.clientX - last.x) / r.width) * 100 * 1.6));
        var ny = Math.max(0, Math.min(100, cur[1] - ((t.clientY - last.y) / r.height) * 100 * 1.6));
        img.style.transformOrigin = nx + '% ' + ny + '%';
      }
      last = { x: t.clientX, y: t.clientY };
    }, { passive: false });
    box.addEventListener('touchend', function () { last = null; });
    modal.__hohLb = { update: update, unzoom: unzoom, box: box };
    return modal.__hohLb;
  }
  var P = customElements.get('product-modal');
  if (!P) return;
  var show = P.prototype.show, hide = P.prototype.hide;
  P.prototype.show = function (opener) {
    show.call(this, opener);
    var lb = setup(this);
    if (!lb) return;
    var active = this.querySelector('.product-media-modal__content > .active');
    if (active) lb.box.scrollLeft = active.offsetLeft;
    lb.update();
  };
  P.prototype.hide = function () {
    if (this.__hohLb) this.__hohLb.unzoom();
    hide.call(this);
  };
})();
